/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfeetitle2Inputs */

const en_ticketsfeetitle2 = /** @type {(inputs: Ticketsfeetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket fee`)
};

const de_ticketsfeetitle2 = /** @type {(inputs: Ticketsfeetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticketgebühr`)
};

/**
* | output |
* | --- |
* | "Ticket fee" |
*
* @param {Ticketsfeetitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfeetitle2 = /** @type {((inputs?: Ticketsfeetitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfeetitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfeetitle2(inputs)
	return de_ticketsfeetitle2(inputs)
});
export { ticketsfeetitle2 as "ticketsFeeTitle" }